import { useSupabase } from "@/components/contexts/DatabaseSyncWrapper";
import {
  useFeaturePrdForCanvas,
  useSupabaseStore,
} from "@/store/zustand/supabaseStore";
import { useCanvasId } from "@/utils/utils";
import _ from "lodash";
import { useCallback } from "react";

const throttledEditSupabase = _.throttle(
  async (
    supabaseClient: any,
    field: string,
    newValue: any,
    canvasId: string
  ) => {
    await supabaseClient
      .from("feature_prd")
      .update({
        [field]: newValue,
      })
      .eq("canvas_id", canvasId);
  },
  1000,
  { leading: true, trailing: true }
);

export const useEditPrd = () => {
  const canvasId = useCanvasId();

  const onDbSnapshot = useSupabaseStore((state) => state.onDbSnapshot);

  const supabaseClient = useSupabaseStore((state) => state.supabaseClient);

  const featurePrd = useFeaturePrdForCanvas();
  return useCallback(
    async (field: string, newValue: any, throttleSupabase?: boolean) => {
      if (!supabaseClient) {
        return;
      }

      if (newValue === featurePrd?.[field]) {
        return;
      }

      onDbSnapshot("featurePrds", {
        newItems: [{ ...featurePrd, [field]: newValue }],
      });

      if (throttleSupabase) {
        throttledEditSupabase(supabaseClient, field, newValue, canvasId);
      } else {
        await supabaseClient
          .from("feature_prd")
          .update({
            [field]: newValue,
          })
          .eq("canvas_id", canvasId);
      }
    },
    [featurePrd, supabaseClient, canvasId]
  );
};
